module.exports = __webpack_public_path__ + "img/img-108.d4a59ca1.png";